export default __webpack_public_path__ + "static/media/icon_large.f91b0d34.jpg";